import { createRoot } from 'react-dom/client';

import style from '../css/tostify.module.less';

const notify = (rawContent: string | Error, type = 'default', { delay = 2000 }) => {
  let content: string = '';

  if (rawContent instanceof Error) {
    content = rawContent.message;
    console.error(rawContent);
  } else {
    content = rawContent;
  }

  const containerId = 'pohNotify';
  let container = document.getElementById(containerId);
  if (!container) {
    container = document.createElement('div');
    container.setAttribute('id', containerId);
    container.classList.add(style.container);

    document.body.appendChild(container);
  }

  const noty = document.createElement('div') as HTMLDivElement;
  noty.classList.add(style.toast, 'qa-notify', `bg-${type}`, 'animated', 'zoomInRight');

  const root = createRoot(noty);
  root.render(<div className="qa-notify-content">{content}</div>);

  container.appendChild(noty);

  setTimeout(() => {
    noty.parentNode?.removeChild(noty);
  }, delay);
};

export function success(content: string, opts = {}) {
  return notify(content, 'success', opts);
}

export function error(content: string, opts = {}) {
  return notify(content, 'danger', opts);
}

export function err(content: string | Error, opts = {}) {
  return notify(content, 'danger', opts);
}

export function warning(content: string, opts = {}) {
  return notify(content, 'warning', opts);
}

export function warn(content: string, opts = {}) {
  return notify(content, 'warning', opts);
}

export function info(content: string, opts = {}) {
  return notify(content, 'info', opts);
}

export function loading(content: string, opts = {}) {
  return notify(content, 'info', opts);
}

export default {
  success,
  error,
  warning,
  warn,
  info,
  loading,
};
